__turbopack_context__.v({
  "burger": "PatientProfileDrawer-module__-6_eqa__burger",
  "closeButton": "PatientProfileDrawer-module__-6_eqa__closeButton",
  "closeHeader": "PatientProfileDrawer-module__-6_eqa__closeHeader",
  "drawerBody": "PatientProfileDrawer-module__-6_eqa__drawerBody",
  "drawerCloseButton": "PatientProfileDrawer-module__-6_eqa__drawerCloseButton",
  "drawerContent": "PatientProfileDrawer-module__-6_eqa__drawerContent",
  "listButton": "PatientProfileDrawer-module__-6_eqa__listButton",
  "logoutButton": "PatientProfileDrawer-module__-6_eqa__logoutButton",
  "menu": "PatientProfileDrawer-module__-6_eqa__menu",
  "menuRoot": "PatientProfileDrawer-module__-6_eqa__menuRoot",
});
